<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Mercados</h1>
          <b-spinner v-if="loading" variant="primary" class="ml-2" small label="Small Spinner"></b-spinner>
        </b-col>
        <b-col>
          <router-link
            :to="{ name: 'comercial-mercados-edit', params: { id: 0 } }"
            class="float-right btn btn-secondary"
            >Crear mercado</router-link
          >
        </b-col>
      </b-row>

      <v-client-table :data="tableData" :columns="columns" :options="options" v-if="ready">
        <template #actions="props">
          <router-link :to="{ name: 'comercial-mercados-edit', params: { id: props.row.id } }">Editar</router-link>
        </template>
        <template #s_accepted_varieties="row">
          <span class="pr-1" v-for="(val, vIndex) in row.row['s_accepted_varieties']" :key="vIndex">
            <b-badge>{{ val }}</b-badge>
          </span>
        </template>
        <template #s_accepted_containers="row">
          <span class="pr-1" v-for="(val, vIndex) in row.row['s_accepted_containers']" :key="vIndex">
            <b-badge>{{ val }}</b-badge>
          </span>
        </template>
        <template #s_accepted_classifications="row">
          <span class="pr-1" v-for="(val, vIndex) in row.row['accepted_classifications']" :key="vIndex">
            <b-badge>{{ val }}</b-badge>
          </span>
        </template>
        <template #accepted_certs="row">
          <span class="pr-1" v-for="(val, vIndex) in row.row['accepted_certs']" :key="vIndex">
            <b-badge>{{ val }}</b-badge>
          </span>
        </template>
        <template #accepted_certs_or="row">
          <span class="pr-1" v-for="(val, vIndex) in row.row['accepted_certs_or']" :key="vIndex">
            <b-badge>{{ val }}</b-badge>
          </span>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableTexts from "../../lang/tableTexts";
export default {
  name: "Users",
  components: {},
  data() {
    return {
      ready: false,
      loading: true,
      columns: [
        "name",
        "s_accepted_varieties",
        "accepted_certs",
        "accepted_certs_or",
        "s_accepted_classifications",
        "s_accepted_containers",
        "actions"
      ],
      badgeColumns: ["s_accepted_varieties", "accepted_certs", "accepted_certs_or", "s_accepted_classifications", "s_accepted_containers"],
      tableData: [],
      options: {
        texts: tableTexts,
        columnsClasses: {
          actions: "w-5 text-center"
        },
        headings: {
          name: "Mercado",
          s_accepted_varieties: "Variedades",
          accepted_certs: "Certificados (y)",
          accepted_certs_or: "Certificados (ó)",
          s_accepted_classifications: "Clasificaciones",
          s_accepted_containers: "Formatos",
          actions: ""
        }
      }
    };
  },
  filters: {
    datetime(value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  methods: {
    async getData() {
      try {
        const response = await this.$axios.get("/api/comex/market/?no_page");
        this.tableData = response.data;
        this.ready = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.ready = true;
        this.loading = false;
      }
    }
  },
  mounted() {
    moment.locale("es");
    this.getData();
  }
};
</script>

<style scoped>
>>> .VueTables__filters-row.form-control {
  height: calc(0.5em + 0.75rem + 2px);
}

>>> .VuePagination {
  text-align: center;
  justify-content: center;
}

>>> .table td {
  padding: 0.15em;
}

>>> .vue-title {
  text-align: center;
  margin-bottom: 10px;
}

>>> .VueTables__search-field {
  display: flex;
}
>>> .VueTables__search-field input {
  margin-left: 0.12rem;
}

>>> .VueTables__limit-field {
  display: flex;
}

>>> .VueTables__limit-field select {
  margin-left: 0.1rem !important;
}

>>> .VueTables__table th {
  text-align: center;
  padding: 0.1rem;
}

>>> .VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

>>> .VueTables__child-row-toggler--closed::before {
  content: "+";
}
>>> .VueTables__columns-dropdown {
  padding-right: 20px;
}
>>> .VueTables__date-filter {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__number-field {
  border: 4px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__child-row-toggler--open::before {
  content: "-";
}
</style>
